import { Component } from 'react';
import { hardReloadApp, isChunkLoadError } from '../utils/assetCache';
import RouteErrorFallback from './RouteErrorFallback';

export default class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (isChunkLoadError(error)) {
      hardReloadApp({ reason: 'chunk' });
      return { hasError: false };
    }
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (isChunkLoadError(error)) {
      hardReloadApp({ reason: 'chunk' });
      return;
    }
    try {
      const message = String(error?.message || error || '').slice(0, 300);
      const stack = String(error?.stack || '').slice(0, 900);
      const comp = String(info?.componentStack || '').slice(0, 900);
      sessionStorage.setItem('vb_route_err', message);
      sessionStorage.setItem('vb_route_err_stack', `${stack}\n---\n${comp}`.slice(0, 1500));
    } catch {}
  }

  render() {
    if (this.state.hasError) {
      return (
        <RouteErrorFallback
          onRetry={() => {
            this.setState({ hasError: false });
            hardReloadApp({ reason: 'chunk' });
          }}
        />
      );
    }
    return this.props.children;
  }
}
